import { logos } from '../hooks/utils/logos';

export const getLogo = async (siteName: string | undefined): Promise<string | null> => {
  if (!siteName) {
    return null;
  }

  try {
    const logoName = logos[siteName];
    if (!logoName) {
      return null;
    }

    const img = await import(`../assets/brands/${logoName}.webp`);
    return img.default;
  } catch {
    return null;
  }
};
